export const enum MyAccountViewCssSelectorEnum {
  element = '[data-qs=my-account]',
  propertyList = '[data-qs=property-list]',
  menu = '[data-qs=my-account-menu]',
  header = '[data-qs=my-account-header]',
  myNotesLink = '[data-qs=my-notes-link]',
  savedSearchCount = '[data-qs=saved-search-count]',
  savedSearchList = '[data-qs=SaveSearchListComponent]',
}
